import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export const SleepHours = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: LocalStorageKeys[RoutePath.SleepHours],
        defaultValue: '',
    });

    const { pageConfiguration } = useContext(BaseContext);

    const handleClick = (answer: ChoiceType) => {
        setPageValue(answer.key);
        saveAnswers({
            key: 'sleep-hours',
            itemQuestion: { question: t('sleep-hours-title'), value: t(answer.value) },
        });

        pageConfiguration.handleOnPageComplete(answer.value);
    };

    const answers: ChoiceType[] = [
        {
            key: '4-less-hours',
            value: t('sleep-hours-option-4-less-hours'),
        },
        {
            key: '5-6-hours',
            value: t('sleep-hours-option-5-6-hours'),
        },
        {
            key: '7-8-hours',
            value: t('sleep-hours-option-7-8-hours'),
        },
        {
            key: '8-more-hours',
            value: t('sleep-hours-option-8-more-hours'),
        },
    ];

    return (
        <>
            <Typography variant={TypographyVariants.h1}>{t('sleep-hours-title')}</Typography>

            {answers.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === pageValue}
                    typographyText={v.value}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
